<alert *ngFor="let alert of alerts" [type]="alert.type" [dismissOnTimeout]="alert.timeout" (onClosed)="onClosed(alert)" class="centered-alert">
    {{ alert.msg }}
    <!-- {{ alert | json}} -->
</alert>